export const SUBMIT_FORM = 'submitForm';
export const FETCH_FORTNOX = 'fetchFortnox';